import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { getDrivers } from "../../services/driver.service";
import "./AssignDriverModal.css";
export default function AssignDriverModal({ order, onAssign, onClose }) {

  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(false);
const [search, setSearch] = useState("");
  useEffect(() => {
    if (order) loadDrivers();
  }, [order]);


  async function loadDrivers() {
  try {
    setLoading(true);
    const response = await getDrivers({ approve: 'approved', per_page: 100 }); 
    const driversArray = response.data || (Array.isArray(response) ? response : []);
    setDrivers(driversArray);
  } catch (e) {
    console.error("Erreur drivers:", e);
    setDrivers([]);
  } finally {
    setLoading(false);
  }
}

const filteredDrivers = drivers
  .filter((d) => d.isApproved === true) 
  .filter((d) =>
   `${d.user?.firstName || ""} ${d.user?.lastName || ""} ${d.user?.contact?.tel || ""}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

 if (!order) return null;

  return (
    <div className="assignOverlay" onClick={onClose}>
  <div className="assignModal" onClick={(e) => e.stopPropagation()}>

    <div className="assignHeader">
      <h3>Assigner un chauffeur</h3>
      <button className="assignCloseBtn" onClick={onClose}>
        <X size={18} />
      </button>
    </div>

    <div className="assignSearch">
      <input
        type="text"
        placeholder="Rechercher un chauffeur..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
    </div>

    {loading && <div className="assignLoading">Chargement...</div>}

    {!loading && (
      <div className="assignDriversContainer">

        {filteredDrivers.map((driver) => (

          <div key={driver.id} className="assignDriverCard">

            <div className="assignDriverLeft">

              <div className="assignDriverAvatar">
                {driver.user?.firstName?.[0] || "?"}
              </div>

              <div className="assignDriverInfos">
                <div className="assignDriverName">
                  {driver.user?.firstName || "N/A"} {driver.user?.lastName || ""}
                </div>

                <div className="assignDriverPhone">
                  {driver.user?.contact?.tel || "Non disponible"}
                </div>
              </div>

            </div>

            <button
              className="assignDriverBtn"
              onClick={() => onAssign(order, driver.id)}
            >
              Assigner
            </button>

          </div>

        ))}

      </div>
    )}

  </div>
</div>
  );
}